import markApplyRecords from "./markApplyRecords";

const markApplyRecordService = [{
    matcher: 'cropMarkApplyRecords',
    reply: config => {
        return [200, markApplyRecords]
    }
},{
    matcher: /cropMarkApplyRecords\/(.*)/,
    reply: config => {
        const id = /cropMarkApplyRecords\/(.*)/.exec(config.url)[1];
        const data = markApplyRecords.find(app => app.id === id);
        return [200, data];
    }
}]

export default markApplyRecordService